import { render, staticRenderFns } from "./loadTransferAdd.vue?vue&type=template&id=24cefa39&"
import script from "./loadTransferAdd.vue?vue&type=script&lang=js&"
export * from "./loadTransferAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports